"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _default = function _default(a) {
  var b, c;

  switch (a.get) {
    case "popular":
      b = "media/popular";
      break;

    case "tagged":
      if (!a.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
      b = "tags/".concat(a.tagName, "/media/recent");
      break;

    case "location":
      if (!a.locationId) throw new Error("No location specified. Use the 'locationId' option.");
      b = "locations/".concat(a.locationId, "/media/recent");
      break;

    case "user":
      if (!a.userId) throw new Error("No user specified. Use the 'userId' option.");
      b = "users/".concat(a.userId, "/media/recent");
      break;

    default:
      throw new Error("Invalid option for get: ".concat(a.get, "."));
  }

  return c = "".concat("https://api.instagram.com/v1", "/").concat(b), c = null == a.accessToken ? "".concat(c, "?client_id=").concat(a.clientId) : "".concat(c, "?access_token=").concat(a.accessToken), null != a.limit && (c = "".concat(c, "&count=").concat(a.limit)), c;
};

exports.default = _default;